<template>
  <div class="fts-signature">
    <template v-if="modalMode">
      <div
        class="signature-placeholder"
        @click="modalShow"
        v-if="isSigned"
      >
        <fts-badge color="primary">
          signed
        </fts-badge>
      </div>

      <div
        class="signature-placeholder"
        @click="modalShow"
        v-else
      >
        <fts-badge color="text">
          <font-awesome-icon :icon="['fas', 'hand-point-right']" /> sign here
        </fts-badge>
      </div>

      <fts-client-modal
        :append-to-body="appendToBody"
        width="400px"
        :title="item.label || item.displayName"
        class="signature-modal"
        ref="ftsClientModal"
      >
        <div slot="body" class="signature-modal-container">
          <fts-display 
            :vector-id="vectorId"
            :form-data="formData" 
            :item="item" 
            file-preview-disabled
            v-if="isSigned"
          />

          <vueSignature
            ref="signature"
            :sigOption="option"
            w="300px"
            h="150px"
            :disabled="disabled"
            :defaultUrl="dataUrl"
            :key="`modal-${uid}`"
            v-else-if="uid"
            @mouseover.native="clearSelection"
          />
        </div>

        <template #footerRight>
          <fts-btn color="danger" outline @click="clear">
            <font-awesome-icon :icon="['fas', 'times']" /> Clear
          </fts-btn>

          <fts-btn color="primary" outline @click="save" v-if="!isSigned">
            <font-awesome-icon :icon="['fas', 'check']" /> Signed
          </fts-btn>
        </template>
      </fts-client-modal>
    </template>

    <template v-else>
      <fts-display 
        :form-data="formData" 
        :item="item" 
        :vector-id="vectorId"
        v-if="isSigned"
      />

      <vueSignature
        class="signature-wrapper"
        ref="signature"
        :sigOption="option"
        w="300px"
        h="150px"
        :disabled="disabled"
        :defaultUrl="dataUrl"
        :key="uid"
        v-else-if="uid"
        @mouseover.native="clearSelection"
      />

      <div class="signature-action">
        <div class="signature-action-btn danger-btn" @click="clear">
          <font-awesome-icon :icon="['fas', 'times']" />
          <div class="action-btn-label">Clear</div>
        </div>
        <div class="signature-action-btn primary-btn" @click="save" v-if="!isSigned">
          <font-awesome-icon :icon="['fas', 'check']" />
          <div class="action-btn-label">Signed</div>
        </div>
      </div>
    </template> 

    <fts-file-upload style="display: none;" 
      :form-data="formData" 
      :item="item" 
      :vector-id="vectorId" 
      ref="upload"
      @input="input"
    />
  </div>
</template>
<script>
import moment from "moment";
import vueSignature from 'vue-signature';

import FTSBadge from './FTSBadge';
import FTSBtn from './FTSBtn';
import FTSClientModal from './FTSClientModal';
import FTSDisplay from './FTSDisplay';
import FTSFile from './file/FTSFile';
import FTSFileUpload from './FTSFileUpload';

export default {
  components: {
    "fts-badge": FTSBadge,
    "fts-btn": FTSBtn,
    "fts-client-modal": FTSClientModal,
    "fts-display": FTSDisplay,
    "fts-file": FTSFile,
    "fts-file-upload": FTSFileUpload,
    vueSignature
  },
  props: {
    appendToBody: Boolean,
    vectorId: [ Number, String ],
    formData: Object,
    item: Object,
    modalMode: Boolean
  },
  data() {
    return {
      uid: null,
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)"
      },
      disabled: false,
      dataUrl: "",
      signed: false,
    };
  },
  methods: {
    save() {
      var _this = this;
      if (_this.$refs.signature.isEmpty()) {
        this.input();
      } else {
        _this.$refs.signature.addWaterMark({
          text: moment(new Date()).format('DD/MM/YYYY HH:mm Z'), // watermark text, > default ''
          font: "16px Arial", // mark font, > default '20px sans-serif'
          style: "fill", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
          fillStyle: "lightgray", // fillcolor, > default '#333'
          strokeStyle: "lightgray", // strokecolor, > default '#333'
          x: 60, // fill positionX, > default 20
          y: 80, // fill positionY, > default 20
          sx: 40, // stroke positionX, > default 40
          sy: 40 // stroke positionY, > default 40
        });

        _this.disabled = true;
        // var png = _this.$refs.signature.save();
        var jpeg = _this.$refs.signature.save("image/jpeg");
        // var svg = _this.$refs.signature.save("image/svg+xml");
        // console.log(png);
        _this.$refs.upload.uploadDataUrl(jpeg);

        console.log(jpeg);

        if (this.modalMode && this.$refs.ftsClientModal) {
          this.$refs.ftsClientModal.close();
        }

        _this.signed = true;
        // console.log(svg);
      }
    },
    clear() {
      var _this = this;
      if(!_this.isSigned) {
        _this.$refs.signature.clear();
      }

      _this.disabled = false;
      _this.signed = false;
      _this.formData[_this.item.fieldName] = null;
      _this.input();
    },
    undo() {
      var _this = this;
      _this.signed = false;
      _this.$refs.signature.undo();
    },
    addWaterMark() {
      var _this = this;
      _this.$refs.signature.addWaterMark({
        text: moment(new Date()).format('DD/MM/YYYY hh:mm'), // watermark text, > default ''
        font: "16px Arial", // mark font, > default '20px sans-serif'
        style: "fill", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
        fillStyle: "lightgray", // fillcolor, > default '#333'
        strokeStyle: "lightgray", // strokecolor, > default '#333'
        x: 50, // fill positionX, > default 20
        y: 100, // fill positionY, > default 20
        sx: 50, // stroke positionX, > default 40
        sy: 100 // stroke positionY, > default 40
      });
    },
    fromDataURL(url) {
      var _this = this;
      _this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
    },
    handleDisabled() {
      var _this = this;
      _this.disabled = !_this.disabled;
    },
    input(val) {
      this.$emit("input", val);
    },
    clearSelection() {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {
        document.selection.empty();
      }
    },
    modalShow() {
      this.$refs.ftsClientModal && this.$refs.ftsClientModal.show();
    }
  },
  computed: {
    isSigned() {
      let data = this.formData[this.item.fieldName]
      if(data && data.path) {
        this.signed = true
        return true
      } else {
        this.signed = false
        return false
      }
    }
  },
  mounted() {
    this.uid = this._uid
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-signature {
  .signature-wrapper {
    border: 1px solid var(--fts-form-control-border);
  }
  .signature-action {
    display: flex;
    justify-content: flex-end;
    width: 300px;
    padding: 4px;
    font-size: .75rem;
    background: var(--fts-gray-100);
    .signature-action-btn {
      padding: .375rem .75rem;
      display: flex;
      align-items: center;
      margin: 2px;
      background: var(--fts-card-background);
      color: var(--fts-gray-400);
      font-size: .75rem;
      line-height: 1.5;
      cursor: pointer;
      &.primary-btn {
        color: var(--fts-primary);
      }
      &.danger-btn {  
        color: var(--fts-danger);
      }    
      svg {
        margin-right: .375rem;
      }
      .action-btn-label {
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: .0892857143em;
      }
    }
  }
  .signature-placeholder {
    height: 100%;
    width: 100%;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
  }
}

.signature-modal {
  .signature-modal-container {
    display: flex;
    justify-content: center;
    > * {
      min-width: 302px;
      min-height: 152px;
      border: 1px solid var(--fts-border);
    }
  }
}
// override style vueSignature
canvas {
  width: 100%;
  height: 100%;
}
</style>